import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ElevatorIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ElevatorIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.6026 2H3.47754C2.96063 2 2.54004 2.42059 2.54004 2.9375V21.0625C2.54004 21.5794 2.96063 22 3.47754 22H21.6026C22.1195 22 22.5401 21.5794 22.5401 21.0625V2.9375C22.5401 2.42059 22.1195 2 21.6026 2ZM13.126 9.13544H18.0842V20.8281H13.126V9.13544ZM11.9541 20.8281H6.9959V9.13544H11.9541V20.8281ZM21.3682 20.8281H19.2561V8.5495C19.2561 8.22591 18.9937 7.96356 18.6701 7.96356H6.40996C6.08637 7.96356 5.82402 8.2259 5.82402 8.5495V20.8281H3.71191V3.17187H21.3682V20.8281Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.23692 6.67426C8.50059 6.86176 8.86641 6.80008 9.05403 6.53645L9.47501 5.94461L9.89599 6.53645C10.0837 6.80028 10.4496 6.86172 10.7131 6.67426C10.9768 6.48668 11.0385 6.12086 10.8509 5.85715L9.95247 4.59414C9.71895 4.2659 9.23087 4.26617 8.99755 4.59414L8.09911 5.85715C7.91153 6.12082 7.97321 6.48664 8.23692 6.67426Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.1276 6.53641C15.3611 6.86465 15.8492 6.86438 16.0825 6.53641L16.981 5.2734C17.1686 5.00973 17.1068 4.64387 16.8432 4.45629C16.5795 4.26871 16.2136 4.33043 16.0261 4.5941L15.6051 5.18594L15.1841 4.5941C14.9965 4.33039 14.6307 4.26871 14.367 4.45629C14.1033 4.64387 14.0416 5.00969 14.2292 5.2734L15.1276 6.53641Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ElevatorIcon;
